import Card from './Card.vue';

export default Card;



// WEBPACK FOOTER //
// ./src/pages/profile/components/info/components/card/index.ts